<script>
import { StoryPageElementMixin } from "%/dynamic-component-editor/standard-pages/story-page/story-page-element-mixin";
import { useCompletionStatusStore } from "%/dynamic-component-editor/stores/completion-status-store";
import TextElement
  from "%/dynamic-component-editor/standard-elements/text-element/TextElement.vue";
import BrandedTextStyleOptions from "%/dynamic-component-editor/bundles/branded-text-style-options";
import FolderCountField from "%/dynamic-component-editor/options/folder-count-field";
import { ELEMENT_PANEL_FOLDER } from "%/dynamic-component-editor/constants/element-panel-folder-names";

export default {
  name: "FolderCompletionCount",
  elementPanelSettings: {
    folder: ELEMENT_PANEL_FOLDER.FOLDERS,
    displayName: "Folder Count",
    displayIcon: "material-symbols:numbers",
    elementGroup: "storyElements",
    elementType: "element",
  },
  extends: TextElement,
  mixins: [StoryPageElementMixin],
  options: [
    FolderCountField,
  ],
  optionBundles: [
    new BrandedTextStyleOptions({}, {
      "text-option": true,
    }),
  ],
  computed: {
    isEditable() {
      return false;
    },
    shouldShowText() {
      return this.editMode || this.entity.isFolder;
    },
    value() {
      const counts = useCompletionStatusStore().folderCountsFor(this.storyEntityId, this.entity);
      const count = counts[this.getOptionValue(FolderCountField)];
      return count == null ? "" : String(count);
    },
  },
};
</script>
